module.exports = __webpack_public_path__ + "static/media/invitado3.063859ae.jpg";